import { Button } from '@tremor/react';
import clsx from 'clsx';
import { GoogleGIcon } from './GoogleGIcon';
import { authTremorButtonNoFocusRing } from '../authFormTremor';
import type { AuthMode } from '../firebaseAuthTypes';

interface AuthBottomSectionProps {
  readonly mode: AuthMode;
  readonly compact?: boolean;
  readonly formDisabled: boolean;
  readonly onGoogle: () => Promise<void>;
  readonly onSelectLogin: () => void;
  readonly onSelectRegister: () => void;
}

export function AuthBottomSection({
  mode,
  compact = false,
  formDisabled,
  onGoogle,
  onSelectLogin,
  onSelectRegister,
}: AuthBottomSectionProps) {
  return (
    <div className={compact ? 'space-y-2' : 'space-y-3'}>
      <div className="relative">
        <div className="absolute inset-0 flex items-center" aria-hidden>
          <div className="w-full border-t border-gray-200" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="bg-white/95 px-3 text-gray-500">or</span>
        </div>
      </div>

      <Button
        type="button"
        variant="secondary"
        color="rose"
        icon={GoogleGIcon}
        onClick={onGoogle}
        disabled={formDisabled}
        className={clsx(
          'w-full justify-center gap-2.5 !border-gray-300 !bg-white !font-medium !text-gray-800 !shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:!bg-gray-50 hover:!shadow-md disabled:!translate-y-0 disabled:!opacity-60',
          compact ? '!py-2' : '!py-2.5',
          authTremorButtonNoFocusRing,
        )}
      >
        Continue with Google
      </Button>

      <div className="flex gap-0.5 rounded-xl border border-gray-200 bg-gray-50 p-0.5">
        <Button
          type="button"
          variant="light"
          color="rose"
          onClick={onSelectLogin}
          className={clsx(
            'flex-1 rounded-lg py-2 text-sm font-semibold transition-all duration-200',
            mode === 'login'
              ? '!border-0 !bg-primary-500 !text-white !shadow-md hover:!bg-primary-600'
              : '!border-0 !bg-transparent !text-gray-600 !shadow-none hover:!bg-gray-100 hover:!text-gray-900',
            authTremorButtonNoFocusRing,
          )}
        >
          Log in
        </Button>
        <Button
          type="button"
          variant="light"
          color="rose"
          onClick={onSelectRegister}
          className={clsx(
            'flex-1 rounded-lg py-2 text-sm font-semibold transition-all duration-200',
            mode === 'register'
              ? '!border-0 !bg-primary-500 !text-white !shadow-md hover:!bg-primary-600'
              : '!border-0 !bg-transparent !text-gray-600 !shadow-none hover:!bg-gray-100 hover:!text-gray-900',
            authTremorButtonNoFocusRing,
          )}
        >
          Create account
        </Button>
      </div>
    </div>
  );
}
